export default {"src":"/_next/static/media/youtube.9be17684.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};